var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "address",
    { staticClass: "address-text" },
    [
      _vm.address.country === "MX"
        ? [
            _vm.address.street
              ? _c("span", [_vm._v(_vm._s(_vm.address.street)), _c("br")])
              : _vm._e(),
            _vm._v(" "),
            _vm.address.street2
              ? _c("span", [_vm._v(_vm._s(_vm.address.street2)), _c("br")])
              : _vm._e(),
            _vm._v(" "),
            _vm.address.district
              ? _c("span", [_vm._v(_vm._s(_vm.address.district)), _c("br")])
              : _vm._e(),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(_vm.address.postalCode) +
                  " " +
                  _vm._s(_vm.address.city) +
                  ", " +
                  _vm._s(_vm.address.region)
              ),
              _c("br"),
            ]),
          ]
        : _vm.address.country == "US" || _vm.address.country == "CA"
        ? [
            _c("span", [_vm._v(_vm._s(_vm.address.street)), _c("br")]),
            _vm._v(" "),
            _vm.address.street2
              ? _c("span", [_vm._v(_vm._s(_vm.address.street2)), _c("br")])
              : _vm._e(),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(_vm.address.city) +
                  ", " +
                  _vm._s(_vm.address.region) +
                  " " +
                  _vm._s(_vm.address.postalCode)
              ),
              _c("br"),
            ]),
          ]
        : [
            _c("span", [_vm._v(_vm._s(_vm.address.street)), _c("br")]),
            _vm._v(" "),
            _vm.address.street2
              ? _c("span", [_vm._v(_vm._s(_vm.address.street2)), _c("br")])
              : _vm._e(),
            _vm._v(" "),
            _vm.address.district
              ? _c("span", [_vm._v(_vm._s(_vm.address.district)), _c("br")])
              : _vm._e(),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(_vm.address.city) +
                  ", " +
                  _vm._s(_vm.address.region) +
                  " " +
                  _vm._s(_vm.address.postalCode)
              ),
              _c("br"),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }